import { Location } from "@angular/common";
import { Component, ViewChild } from "@angular/core";
import { CreatePlayerFormComponent } from "./create-player-form.component";

@Component({
    selector: "bbwt-create-player-routing",
    template: `<div class="card">
        <h1>Create <naming-convention-label [singular]="true"></naming-convention-label></h1>

        <create-player-form (playerCreated)="reset()" (cancel)="back()"></create-player-form>
    </div>`
})
export class CreatePlayerRoutingComponent {
    @ViewChild(CreatePlayerFormComponent)
    createPlayerForm: CreatePlayerFormComponent;

    constructor(private location: Location) {}

    back() {
        this.location.back();
    }

    reset() {
        this.createPlayerForm?.playerForm.reset();
    }
}
